import {
  SHOW_ALERT,
  REMOVE_ALERT,
  CLOSE_ALL_ALERTS
} from '../actions/actionTypes';

const initialState = {
  alerts: []
};

export const alertsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ALERT:
      return {
        ...state,
        alerts: [
          ...state.alerts,
          {
            ...action.options
          }
        ]
      };
    case REMOVE_ALERT: {
      return {
        ...state,
        alerts: state.alerts.filter((alert) => alert.key !== action.key)
      };
    }

    case CLOSE_ALL_ALERTS: {
      return {
        ...state,
        alerts: state.alerts.map((alert) => ({ ...alert, fechar: true }))
      };
    }

    default:
      return state;
  }
};
